import {
  Button,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  Stack,
  TextField,
} from '@mui/material'
import { Box } from '@mui/system'
import { getCodeSetLabelLookup } from '../../../Functions/CodeSetFns'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { listFromCodes } from '../../../Functions/ListItemGenerator'
import { useNavigate, useParams } from 'react-router-dom'
import { useMessagePopupContext } from '../../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useUserContext } from '../../../Contexts/UserConfig'
import NewScreenStepper from './NewScreenStepper'
import PageSection from '../../../Constants&Theme/PageSection'
import { stackGap } from '../../../Constants&Theme/Spacing'
import { useStuartMutatePost } from '../../../APIs/Hooks/PhpAPIHooks'
import { useScreenContext } from '../../../Contexts/Modules/HealthModule/SelectedScreenModule'

function CreateScreen({ clone = false }: { clone?: boolean }) {
  const navigate = useNavigate()
  const { screen_id } = useParams()
  const { screenQuery } = useScreenContext()
  const { loginConfig, loadingConfig } = useUserContext()
  const { setMessage } = useMessagePopupContext()

  const [requestName, setRequestName] = useState('')
  const [holdings, setHoldings] = useState<any[]>([])

  const holdingOptions = listFromCodes(
    loginConfig,
    'KV-Holdings',
    loadingConfig,
  )

  useEffect(() => {
    if (clone && screenQuery?.data) {
      setHoldings(screenQuery.data?.Holdings)
      setRequestName(screenQuery.data?.Name)
    }
  }, [clone, screenQuery?.data])

  const { mutate: newScreen } = useStuartMutatePost(
    '/screen/newScreen.php',
    {
      Name: requestName,
      Holdings: holdings,
    },
    async (data) => {
      if (data?.ScreenID) {
        const path = `/stuart/health/screen/${data.ScreenID}`
        if (clone) {
          navigate(path + `/clone/collections/${screen_id}`)
        } else {
          navigate(path + '/collections')
        }
      } else {
        setMessage({
          subject: 'Error',
          severity: 'warning',
          message:
            data?.message ??
            'An unexpected error occurred changing the vessel holding',
        })
      }
    },
  )

  return (
    <Box sx={{ width: 1 }}>
      <NewScreenStepper step={0}>
        <PageSection
          title={`${clone ? 'Clone' : 'New'} Screen Request`}
          loading={clone && screenQuery.isLoading}
        >
          <Stack
            sx={{ maxWidth: 'sm' }}
            width={1}
            gap={stackGap.col}
          >
            <TextField
              required
              autoFocus
              label="Request Name"
              value={requestName}
              onChange={(e) => setRequestName(e.target.value)}
              fullWidth
            />
            <FormControl
              required
              fullWidth
            >
              <InputLabel>Holdings</InputLabel>
              <Select
                label="Holdings"
                multiple
                value={holdings || ''}
                name="holdings"
                onChange={(e) =>
                  setHoldings(
                    Array.isArray(e.target.value) ?
                      e.target.value
                    : [e.target.value],
                  )
                }
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                    {selected.map((value) => (
                      <Chip
                        sx={{ m: 1 / 3 }}
                        key={value}
                        label={getCodeSetLabelLookup(
                          loginConfig,
                          ['KV-Holdings'],
                          value,
                        )}
                      />
                    ))}
                  </Box>
                )}
              >
                {holdingOptions}
              </Select>
            </FormControl>
            <Stack
              alignItems={'center'}
              gap={1 / 2}
            >
              <Box>
                <Button
                  onClick={() => newScreen()}
                  fullWidth
                  variant="contained"
                  color="primary"
                  disabled={!requestName || holdings.length === 0}
                >
                  Save & Continue
                </Button>
              </Box>
              <FormHelperText>
                Holdings cannot be edited later. Next step will enable adding
                collections
              </FormHelperText>
            </Stack>
          </Stack>
        </PageSection>
      </NewScreenStepper>
    </Box>
  )
}

export default CreateScreen
